import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Tenant } from 'src/app/job/models/job-post/job.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class TenantService extends BaseService {
  private readonly urlPrefix = `${environment.agencyMgmt.urlPrefix}/tenant`;

  constructor(http: HttpClient) {
    super(http);
  }

  listByPropertyId(propertyId: string,isShowAllTenants: boolean) {
    return this.get<Tenant[]>(
      `${this.urlPrefix}/list-by-propertyId?PropertyId=${propertyId}&IsShowAllTenants=${isShowAllTenants}`
    );
  }
  getTenantSelectionOptions(propertyId: string): Observable<Tenant[]> {
    return this.listByPropertyId(propertyId,false).pipe(
      map((tenants) => {
        let option = new Tenant();
        if (tenants.length > 0) {
          option.name = 'Not Required';
          option.id = null;
        } else {
          option.name = 'Vacant';
          option.id = null;
        }
        tenants.push(option);
        return tenants;
      })
    );
  }
}
